module.exports = __webpack_public_path__ + "img/hips.c68d9c55.png";